/* eslint-disable sort-keys-fix/sort-keys-fix */
import { COMMUNITY_PAGES_PATH_PREFIX, type CommunityData } from "./types"

const S3_PREFIX = "https://media.werz.at/community-assets/section8/"

const SECTION8: CommunityData = {
  code: "section8",
  inviteCode: "section8",
  name: "Section8",
  thumbnail: "",
  favicon: "",
  defaultCurrency: "EUR",
  url: `${COMMUNITY_PAGES_PATH_PREFIX}/sec-008`,
  socials: {},
  waitlist: true,
  styles: {
    comingSoon: {
      bgColor: "#000000",
      hero: {
        desktop: `${S3_PREFIX}web-background.mp4?type=video`,
        mobile: `${S3_PREFIX}web-background-mobile.mp4?type=video`,
        style: "bg-[#222222]",
      },
      logo: {
        desktop: `${S3_PREFIX}web-alternative-logo.png`,
        mobile: `${S3_PREFIX}web-alternative-logo.png`,
        style: "w-[98px] h-[41px] sm:w-[140px] sm:h-[58px]",
      },
      werzLogoColor: "#FFFFFF",
      title:
        "font-['IBMPlexSansCondensedSemiBold'] text-[28px] leading-[120%] text-[#ffffff] uppercase",
      text: "font-['OpenSansRegular'] text-[16px] leading-[120%] text-[#ffffff]",
      button:
        "font-['IBMPlexSansCondensedRegular'] text-[18px] leading-[120%] p-4 rounded bg-[#ff3130] text-[#000000] cursor-pointer w-fit uppercase",
      input: {
        base: "font-['OpenSansRegular'] text-[14px] leading-[120%] w-[256px] px-4 h-[48px] bg-[#222222] text-[#ffffff]",
        border: "#444444",
        borderFocus: "#6d6d6d",
        borderError: "#FF0000",
        errorText: "text-[#FF0000]",
      },
      error: "font-['OpenSansRegular'] text-[14px] leading-[120%] text-[#FF0000]",
      footerText: "font-['OpenSansRegular'] text-[14px] leading-[120%] text-[#6d6d6d]",
      skipButton:
        "font-['OpenSansRegular'] text-[14px] leading-[120%] text-[#6d6d6d] cursor-pointer",
      modal: {
        container: "bg-[#222222] px-[40px] py-[48px]",
        title:
          "font-['IBMPlexSansCondensedSemiBold'] text-[24px] leading-[120%] text-[#ffffff] text-center uppercase",
        text: "font-['OpenSansRegular'] text-[14px] leading-[120%] text-[#6d6d6d] text-center",
        width: "w-[358px]",
        backdrop: "bg-black/50",
        otpInput:
          "!w-[40px] !h-[50px] rounded-[4px] text-[#ffffff] bg-[#000000] font-['OpenSansRegular'] text-[16px] leading-[120%] text-center",
        otpBorder: "#444444",
        otpBorderFocus: "#6d6d6d",
      },
    },
    global: {
      counterColor: "#ffffff",
      logo: {
        src: `${S3_PREFIX}web-logo.jpg`,
        styles: "w-[140px] h-[58px]",
      },
      alternativeLogo: {
        src: `${S3_PREFIX}web-alternative-logo.png`,
        styles: "w-[140px] h-[58px]",
      },
      modalWindow: {
        container: "",
        title: "",
        subtitle: "",
      },
      bgColor: "#000000",
      asideBg: "#222222",
      asideStyles: "border-r border-[#6d6d6d]",
      contentBg: "#000000",
      contentBoxShadow: "",
      bgDesktop: `${S3_PREFIX}web-background.mp4?type=video`,
      bgMobile: `${S3_PREFIX}web-background-mobile.mp4?type=video`,
      nonMemberBg: `${S3_PREFIX}web-background-non-member.mp4?type=video`,
      mainFont: "font-['IBMPlexSansRegular']",
      primaryButton:
        "bg-[#ff3130] border-2 border-[#ff3130] rounded px-[18px] py-[18px] !text-[#000000] font-['IBMPlexSansCondensedRegular'] !text-[18px] uppercase text-left",
    },
    navigation: {
      iconsColor: "#ff3130",
      sideBarSeparator: "border-r-[1px] border-black border-opacity-[15%]",
      separator: "#222222",
      item: "text-[#ff3130] font-['IBMPlexSansCondensedRegular'] text-[18px] uppercase text-left gap-x-[10px] text-opacity-50 text-center border-b border-[#222222] !pl-0 !py-3",
      itemSelected: "!text-opacity-100",
    },
    communityLanding: {
      container: "!bg-[#000000] border-[#a7a7a7] !pb-8",
      titles:
        "text-[#ffffff] font-['IBMPlexSansCondensedSemiBold'] text-[26px] uppercase text-left leading-[110%]",
      emptyOrLoadingState:
        "!mx-4 sm:!mx-8 text-[#fafaf9] font-['IBMPlexSansRegular'] text-[14px] text-left leading-[120%]",
      announcementsV2: {
        sectionContainer: "py-4 sm:py-8 !m-0 space-y-0 !border-0",
        sectionTitle:
          "text-[#ffffff] font-['IBMPlexSansCondensedSemiBold'] text-[26px] uppercase text-left leading-[110%] pl-4 sm:pl-8 !mb-4 sm:!mb-6",
        scrollMenu: {
          container: "content-start hide-scroll pl-4 sm:pl-8 pr-6 sm:pr-8 gap-x-4",
          wrapper: "relative group",
          item: "w-fit",
        },
        item: {
          container:
            "min-w-[calc(100vw-48px)] sm:min-w-[256px] sm:max-w-[256px] overflow-hidden bg-[#ffffff00]",
          mediaContainer: "w-full sm:w-[256px] !aspect-square relative",
          media: "w-full !aspect-square object-cover",
          placeholderMedia: "w-full !aspect-square bg-gray-400",
          content: "flex flex-col py-4 bg-transparent",
          title:
            "text-[#ffffff] font-['IBMPlexSansCondensedSemiBold'] text-[16px] uppercase text-left leading-[110%]",
          subtitle:
            "text-[#fafaf9] font-['OpenSansRegular'] text-[12px] text-left leading-[130%] mt-2",
        },
      },
      eventsV2: {
        sectionContainer: "py-4 sm:py-8 !m-0 space-y-0 !border-0",
        sectionTitle:
          "text-[#ffffff] font-['IBMPlexSansCondensedSemiBold'] text-[26px] uppercase text-left leading-[110%] pl-4 sm:pl-8 !mb-4 sm:!mb-6",
        scrollMenu: {
          container:
            "content-start hide-scroll pl-4 sm:pl-8 pr-6 sm:pr-8 !h-full sm:!h-[128px] flex-row gap-6",
          wrapper: "relative group w-full",
          item: "w-fit",
        },
        item: {
          container:
            "flex sm:flex-row flex-col w-[calc(100vw-56px)] sm:!w-[428px] h-full overflow-hidden bg-[#ffffff00]",
          mediaContainer: "w-full sm:!w-[228px] sm:flex-shrink-0 relative",
          media: "w-full !aspect-video object-cover",
          placeholderMedia: "w-full h-full bg-gray-400",
          content: "flex flex-col px-4 bg-transparent",
          title:
            "text-[#ffffff] font-['IBMPlexSansCondensedSemiBold'] text-[16px] uppercase text-left leading-[110%]",
          subtitle:
            "text-[#fafaf9] font-['OpenSansRegular'] text-[12px] text-left leading-[130%] mt-2",
          location: "text-[#fafaf9] font-['OpenSansRegular'] text-[12px] text-left leading-[130%]",
          date: "text-[#fafaf9] font-['OpenSansRegular'] text-[12px] text-left leading-[130%]",
        },
      },
      shop: {
        container: "py-4 sm:py-8 !pb-16 !m-0 space-y-0 !border-0 overflow-hidden",
        title:
          "text-[#ffffff] font-['IBMPlexSansCondensedSemiBold'] text-[24px] uppercase text-left leading-[110%]",
        text: "text-[#ffffff] font-['OpenSansRegular'] text-[16px] text-left leading-[130%]",
        customShopImageStyle: "",
        sectionTitle:
          "text-[#ffffff] font-['IBMPlexSansCondensedSemiBold'] text-[26px] uppercase text-left leading-[110%] !mb-4 sm:!mb-4",
      },
    },
    eventV2: {
      container: "flex flex-col !bg-[#000000] border-[#a7a7a7] !pb-8",
      eventInfo: {
        container: "flex flex-col sm:flex-row gap-4 sm:gap-6 sm:p-8 p-4",
        media: "sm:!w-[320px] !w-full !h-[180px] object-cover sm:mb-4 !border-0",
        title:
          "text-[#ffffff] font-['IBMPlexSansCondensedSemiBold'] text-[26px] uppercase text-left leading-[110%]",
        subtitle:
          "text-[#fafaf9] font-['IBMPlexSansRegular'] text-[14px] text-left leading-[120%] mb-4 mt-2",
        button:
          "bg-[#ff3130] border-2 border-[#ff3130] rounded px-[18px] py-[18px] !w-fit mb-4 sm:mb-0 text-[#000000] font-['IBMPlexSansCondensedRegular'] text-[18px] uppercase text-left leading-[100%]",
        questions: "text-[14px] text-left leading-[120%] text-[#ffffff]",
      },
      about: {
        container: "flex flex-col gap-4 sm:p-8 p-4",
        header:
          "text-[#ffffff] font-['IBMPlexSansCondensedSemiBold'] text-[24px] uppercase text-left leading-[110%]",
        text: "text-[#ffffff] font-['IBMPlexSansRegular'] text-[14px] text-left leading-[120%] mb-4 w-full",
      },
      location: {
        container: "flex flex-col gap-4 sm:p-8 p-4",
        header:
          "text-[#ffffff] font-['IBMPlexSansCondensedSemiBold'] text-[24px] uppercase text-left leading-[110%]",
        text: "text-[#ffffff] font-['IBMPlexSansRegular'] text-[14px] text-left leading-[120%] mb-4 max-w-[652px] w-full",
        map: "w-full h-[206px] overflow-hidden border border-[#6d6d6d] gap-y-[10px]",
        mapPinColor: "#000000",
        mapStrokeColor: "#6d6d6d",
      },
      downloadWERZ: {
        container: "flex flex-col gap-4 sm:p-8 p-4",
        header:
          "text-[#ffffff] font-['IBMPlexSansCondensedSemiBold'] text-[24px] uppercase text-left leading-[110%]",
        text: "text-[#ffffff] font-['IBMPlexSansRegular'] text-[14px] text-left leading-[120%]",
      },
      tickets: {
        header:
          "text-[#ffffff] font-['IBMPlexSansCondensedSemiBold'] text-[26px] uppercase text-left leading-[110%] px-4 sm:px-8 pt-4 sm:pt-8 pb-2 sm:pb-4",
        outerContainer: "flex flex-col !bg-[#000000] !pb-8",
        innerContainer: "flex flex-col overflow-hidden px-4 sm:px-8",
        ticket: {
          container:
            "flex flex-row justify-between leading-auto !bg-[#ffffff00] border-b border-[#333333] py-4",
          media: "!hidden",
          name: "text-[#ffffff] font-['IBMPlexSansCondensedSemiBold'] text-[16px] uppercase text-left leading-[110%]",
          description:
            "text-[#fafaf9] font-['IBMPlexSansRegular'] text-[14px] text-left leading-[120%] !mt-1 flex flex-row",
          price:
            "text-[#fafaf9] font-['IBMPlexSansCondensedSemiBold'] text-[16px] uppercase text-left leading-[110%] !mt-1",
          quantity:
            "text-[#ffffff] font-['IBMPlexSansCondensedRegular'] text-[14px] uppercase text-left",
          status:
            "text-[#fafaf9] font-['IBMPlexSansCondensedSemiBold'] text-[16px] uppercase text-left leading-[110%]",
          counterContainer:
            "bg-[#000000] border border-[#ff3130] rounded !px-4 !py-3 gap-x-4 !w-fit !h-10",
          button:
            "!bg-[#000000] border border-[#ff3130] rounded px-4 py-3 text-[#ffffff] font-['IBMPlexSansCondensedRegular'] text-[14px] uppercase text-left !w-fit",
          plusMinusColor: "#ffffff",
        },
      },
    },
  },
}

export default SECTION8
